import { motion } from "framer-motion";
import { Download, Bot, Trash2, Archive, X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface BulkActionsBarProps {
  selectedCount: number;
  onClear: () => void;
  onExport?: () => void;
}

export function BulkActionsBar({
  selectedCount,
  onClear,
  onExport,
}: BulkActionsBarProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 flex items-center gap-4 bg-slate-900 text-white px-6 py-3 rounded-full shadow-2xl border border-slate-700/50"
    >
      <div className="flex items-center gap-3 border-r border-slate-700 pr-4">
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary text-xs font-bold text-white">
          {selectedCount}
        </span>
        <span className="text-sm font-medium">Selected</span>
      </div>

      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size="sm"
          onClick={onExport}
          className="text-slate-300 hover:text-white hover:bg-slate-800"
        >
          <Download className="h-4 w-4 mr-2" />
          Export
        </Button>
        {/* <Button variant="ghost" size="sm" className="text-slate-300 hover:text-white hover:bg-slate-800">
          <Bot className="h-4 w-4 mr-2" />
          AI Review
        </Button>
        <Button variant="ghost" size="sm" className="text-slate-300 hover:text-white hover:bg-slate-800">
          <Archive className="h-4 w-4 mr-2" />
          Archive
        </Button> */}
        {/* <Button
          variant="ghost"
          size="sm"
          className="text-rose-400 hover:text-rose-300 hover:bg-rose-500/10"
        >
          <Trash2 className="h-4 w-4 mr-2" />
          Delete
        </Button> */}
      </div>

      <div className="pl-2 border-l border-slate-700">
        <Button
          variant="ghost"
          size="icon"
          onClick={onClear}
          className="h-8 w-8 text-slate-400 hover:text-white rounded-full"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </motion.div>
  );
}
